import { z } from 'zod';

export const DocumentsQuerySchema = z.object({
    entities: z.preprocess(
        (val) => {
            if (typeof val === 'string') {
                try {
                    return JSON.parse(val);
                } catch {
                    return [];
                }
            }
            return val;
        },
        z.array(z.string())
    ).describe('Liste des entités au format stringifié JSON ou tableau de strings (ex: ["candidate:123"])'),
});

export type DocumentsQueryDto = z.infer<typeof DocumentsQuerySchema>;